import { Router } from '@angular/router';
import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { StocksExchangeCheckoutAction } from '@toro/common/shared/state-management/stocks-exchange-checkout/stocks-exchange-checkout.action';
import { UtilsAction } from '@toro/common/shared/state-management/utils/utils.actions';
import { DraftSuccessComponent } from '../draftsuccess/draftsuccess.component';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { LayerService } from '@toro/common/shared/services/LayerService';
import { Draft } from '@toro/common/shared/models/Draft';
import { Component, OnInit, OnDestroy, AfterContentInit } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { FinanceActions } from '@toro/common/shared/state-management/finance/finance.action';
import { FinanceEffects } from '@toro/common/shared/state-management/finance/finance.effects';
import { ApplicationMessagesAction } from '@toro/common/shared/state-management/application-messages/application-message.action';
import { UserProfileActions } from '@toro/common/shared/state-management/userprofile/userprofile.actions';
import { BanksAction } from '@toro/common/shared/state-management/banks/banks.action';
import { FormsUtils } from '@toro/common/shared/resources/forms.utils';
import { Location } from '@angular/common';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { User } from '@toro/common/shared/models/User';
import { Bank } from '@toro/common/shared/models/corporation/bank.model';
import { AuthorizationScenario } from '@toro/common/shared/enum/authorization-scenario.enum';
import { AuthorizationResultPayload } from '@toro/common/shared/models/authorization/authorization-result-payload.model';
import { AuthorizationWraperService } from '@toro/common/shared/services/authorization-wraper/authorization.wraper.service';
import { MatDialogRef } from '@angular/material/dialog';
import { HubAuthorizationComponent } from '@toro/common/shared/components/hub-authorization/hub-authorization.component';
import { FinancePosition } from '@toro/common/shared/models/pos-risk/finance-position';
import { BackendRegistationStatus } from '@toro/common/shared/enum/backend-registration-status.enum';
import { WithdrawalHistoryComponent } from '../withdrawal-history/withdrawal-history.component';
import { WithdrawHistory } from '@toro/common/shared/models/finance/withdraw-history.model';
import { StatusTransfer } from '@toro/common/shared/enum/finance/status-transfer.enum';
import { filter, first } from 'rxjs/operators';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ToastrService } from 'ngx-toastr';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { WithdrawExecutionDate } from '@toro/common/shared/models/finance/withdraw-execution-date.model';
import { OperationalLimitAction } from '@toro/common/shared/state-management/operational-limit/operational-limit.action';
import { WithdrawalLoConfirmComponent } from '../withdrawal-lo-confirm/withdrawal-lo-confirm.component';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

@AutoUnsubscribe()
@Component({
    selector: 'app-draft',
    templateUrl: './draft.component.html',
    styleUrls: ['./draft.component.scss'],
})
export class DraftComponent extends DisposableSafelly implements OnInit, OnDestroy, AfterContentInit {

    public user: User = null;
    public userStatus = BackendRegistationStatus;
    public banks: Bank[] = null;
    public finance: FinancePosition = null;
    public formSimulation: FormGroup;
    public rescueValue: any;
    public withDraw: Draft = new Draft();
    public authentication$: Observable<any>;
    public formBank: FormGroup;
    public isLoading: boolean = true;
    public logoPath = `/assets/images/${environment.isNewBrand ? 'santander': 'toro'}-red-black-small.svg`;
    public haveWithdrawalScheduled = false;
    public hasAccountCommunicationActive = false;
    public withdrawExecutionDate: WithdrawExecutionDate;
    private isMobile: boolean = false;
    private userCblc: number;
    private accountCommunicationBannerTracked = false;

    constructor(
        public FB: FormBuilder,
        public store: Store<AppState>,
        private location: Location,
        public formsUtils: FormsUtils,
        public layerService: LayerService,
        private dialogsService: DialogsService,
        private financeEffects$: FinanceEffects,
        private authorizationPanel: MatDialogRef<HubAuthorizationComponent>,
        private authorizationWraperService: AuthorizationWraperService,
        private router: Router,
        private toastrService: ToastrService
    ) {
        super();
        this.withdrawExecutionDate = new WithdrawExecutionDate();

        // ???
        this.withDraw.BalanceAvailableForWithdrawal = 10;

        // Formulário para o draft
        this.formSimulation = this.FB.group({
            bank: [null, Validators.required],
            rescueValue: [0, [Validators.required, Validators.min(0.01)]],
        });

        this.store.dispatch({ type: UtilsAction.getTimer });
        const currentDate = new Date();
        const currentDateString = currentDate
            .toISOString()
            .split('T')[0]
            .split('-');

        const endDate = new Date();
        endDate.setDate(endDate.getDate() + 1);
        const endDateString = endDate
            .toISOString()
            .split('T')[0]
            .split('-');
        this.store.dispatch({ type: StocksExchangeCheckoutAction.nextWorkingDays, rangeDate: { end: endDateString, today: currentDateString } });
        this.getScreenWidth();

        this.store.dispatch({ type: FinanceActions.getWithdrawHistory });
        this.store.dispatch({ type: FinanceActions.getTransferExecutionDate });
    }

    public setBank() {
        this.layerService.destroyAllOverlays();
    }

    public ngOnInit() {
        // Solicita stores necessárias
        this.store.dispatch({ type: UserProfileActions.getUserByCBLC });
        this.store.dispatch({ type: BanksAction.getItems });
        this.store.dispatch({ type: FinanceActions.getRealtimeFinancePosition });

        this.loadAuthentication();
        this.loadUserProfile();
        this.loadFinance();
        this.loadBanks();
        this.checkWithdrawals();
        this.getCurrentUserCblc();
        this.getWithdrawExecutionDate();
        this.checkAccountCommunication();
    }

    public ngAfterContentInit() {

        const fields = '.form-input--js';
        const labels = '.form-label--js';

        $(fields)
            .on('focus', () => {
                $(this)
                    .addClass('active')
                    .siblings('label')
                    .addClass('active');
            });

        $(fields)
            .on('blur', () => {
                const lengthEl = $(this)
                    .val()
                    .toString().length;
                if (lengthEl < 1) {
                    $(this)
                        .removeClass('active')
                        .siblings('label')
                        .removeClass('active');
                }
            });

        $(labels)
            .on('click', () => {

                const $element = $(this)
                    .next('input');

                $element
                    .addClass('active')
                    .siblings('label')
                    .addClass('active');

                $element.focus();

            });

        this.isAllowedToEdit();
    }

    // Não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    // tslint:disable-next-line: no-empty
    public ngOnDestroy() { }

    /**
     * Controla submit do formulário de saque
     * @param $event
     */
    public submitDraft($event: Event) {
        $event.preventDefault();

        if (!this.isAllowedToDraft()) return;

        this.formsUtils
            .ValidFormBase(this.formSimulation)
            .then(() => {
                // O aviso vem antes da autorização: não faz sentido consumir um token
                // do cliente para só depois perguntar se ele quer seguir com o saque.
                if (this.hasAccountCommunicationActive) {
                    this.confirmWithdrawalWithAccountCommunication();
                    return;
                }

                this.requestAuthorizationAndSchedule();
            });
    }

    /**
     * Identifica se o cliente possui mais
     * que uma conta bancária registrada.
     *
     * Se possuir apenas um banco já o define no form de saque
     */
    public bankAccountsLength(): any {

        // Detecta quantidade de contas
        const banksCurrentLength = this.user.bankAccounts.length;
        const isAccountBank = this.user && this.user.bankAccounts && (banksCurrentLength !== 0);

        if (!isAccountBank) { return 0; }

        // Define form se apenas uma conta
        if (banksCurrentLength === 1) {
            this.formSimulation
                .get('bank')
                .setValue(this.user.bankAccounts[0]);
        }

        return this.user.bankAccounts.length;
    }

    /**
     *
     * loads WithdrawExecutionDate from VF into withdrawExecutionDate var
     */
    public getWithdrawExecutionDate(){
        this.store.select(x => x.finance)
        .subscribe((finance) => {
            this.withdrawExecutionDate = finance.withdrawExecutionDate;
        });
    }

    /**
     * Direciona o cliente para tela anterior de onde ele veio
     * Cliente decidiu cancelar o saque.
     */
    public back() {
        this.location.back();
    }

    /**
     * Retorna o nome de um banco com banse em seu ID
     * @param bankId
     */
    public getBankName(bankId: number): string {
        const bank = this.banks.filter((bankEl) => bankEl.id === bankId)
            .pop();

        return bank && bank.name ? bank.name : '';
    }

    /**
     * Retorna apenas o primeiro nome do clinete
     */
    public getClientFirstName() {
        // tslint:disable-next-line: newline-per-chained-call
        return this.user && this.user.name ? this.user.name.split(' ').reverse().pop() : 'Olá';
    }

    /**
     * Verifica condições mínimas para saque
     */
    public isAllowedToDraft(): boolean {
        return this.formSimulation.valid &&
            !!this.finance.availableForWithdrawal &&
            this.formSimulation.get('rescueValue').value <= this.finance.availableForWithdrawal;
    }

    /**
     * Retorna hora em segundos
     */
    public convHourToSeconds(time: string) {
        if (time) {
            const splitTime = time.split(':');
            if (+splitTime[0] <= 24 && +splitTime[1] <= 59 && +splitTime[2] <= 59) {
                return (+splitTime[0] * 3600) + (+splitTime[1] * 60) + (+splitTime[2]);
            }
        } else {
            return false;
        }
    }

    /**
     * Ordena de forma decrescente um array de objeto
     */
    public compareSort(a, b) {
        const hourA = a.hrsolicitacao;
        const hourB = b.hrsolicitacao;

        let comparison = 0;
        if (hourA > hourB) {
            comparison = -1;
        } else if (hourA < hourB) {
            comparison = 1;
        }
        return comparison;
    }

    /**
     * Verifica se o cliente pode fazer alterações dos dados
     */
    public isAllowedToEdit() {
        return this.user && this.user.registrationStatus === this.userStatus.Ok;
    }

    public redirectAddBankAccount() {
        this.router.navigate(['/minha-conta/dados-bancarios/edit'], { queryParams: { from: 'home/saque' } });
    }

    public goToWithdrawalHistory() {
        this.withdrawalHistoryScreenTracking();
        this.dialogsService.showComponnent(WithdrawalHistoryComponent);
    }

    public roundingToValue(valueToWithdrawal): number {
        const digits = 2;
        return valueToWithdrawal ? Math.floor(valueToWithdrawal * (10 ** digits)) / (10 ** digits) : 0;
    }

    /**
     * Direciona o cliente para o feedback da solicitação de saque.
     */
    private goToFeedbackMessage() {
        this.dialogsService.showComponnent(DraftSuccessComponent, {
            value: this.formSimulation.value.rescueValue,
            bankAccount: this.formSimulation.value.bank,
            bankName: this.getBankName(this.formSimulation.value.bank.bankID),
            hasAccountCommunicationActive: this.hasAccountCommunicationActive
        });
    }

    /**
     * Identifica se o cliente possui a Comunicação entre Contas (Limite Operacional) ativa.
     *
     * O termo é considerado ativo tanto no status "Aceito" quanto "Pendente",
     * conforme retorno de `isAccepted` em /operational-limit/acceptance-term/{cblc}.
     */
    private checkAccountCommunication() {
        this.disposableSubscriptions.push(
            this.store
                .select((state) => state.operationalLimit)
                .pipe(filter((operationalLimit) => !!operationalLimit && !operationalLimit.pending))
                .subscribe((operationalLimit) => {
                    this.hasAccountCommunicationActive = operationalLimit.value?.isAccepted === true;

                    this.trackAccountCommunicationBanner();
                })
        );
    }

    /**
     * Abre a caixa de autorização e agenda a transferência quando o token estiver disponível.
     */
    private requestAuthorizationAndSchedule() {
        this.authorizationPanel = this.authorizationWraperService
            .requestUserAuthorization(AuthorizationScenario.AuthorizeAction);

        this.disposableSubscriptions.push(
            this.authorizationPanel.componentInstance.onTokenAvaliable
                .subscribe((token: AuthorizationResultPayload) => this.scheduleTransfer(token))
        );
    }

    /**
     * Intercepta o saque manual do cliente com Comunicação entre Contas ativa,
     * antes de pedir a autorização por token.
     *
     * Se o cliente insistir no saque, segue para a autorização.
     * Se desistir, o fluxo é encerrado e o cliente é direcionado para a home logada.
     */
    private confirmWithdrawalWithAccountCommunication() {
        this.disposableSubscriptions.push(
            this.dialogsService
                .showComponnent(
                    WithdrawalLoConfirmComponent,
                    { value: this.formSimulation.value.rescueValue },
                    true,
                )
                .afterClosed()
                .subscribe((hasConfirmed: boolean) => {
                    if (!hasConfirmed) {
                        this.router.navigate(['/']);
                        return;
                    }

                    this.requestAuthorizationAndSchedule();
                })
        );
    }

    /**
     * Solicita o agendamento da transferência para a conta bancária selecionada.
     */
    private scheduleTransfer(token: AuthorizationResultPayload) {
        this.trackSubmitDraft();

        // Muda o modelo de risco do usuário para o modelo parametrizado
        this.store.dispatch({
            type: FinanceActions.getSheduleTransfer,
            payload: {
                value: this.formSimulation.value.rescueValue,
                userAccountId: this.formSimulation.value.bank.id,
            },
            ...token,
        });
    }

    /**
     * Dispara evento para exibição de erro comum
     * @param payload
     */
    private dispatchGenericError(payload: any) {
        this.store.dispatch({ type: ApplicationMessagesAction.genericError, payload });
    }

    /**
     * Carrega dados de usuário do cliente
     */
    private loadUserProfile() {
        this.store.select((store) => store.userProfile)
            .subscribe((userProfile) => {
                this.user = userProfile.user;
            });
    }

    /**
     * Carrega lista de bancos cadastrados
     */
    private loadBanks() {
        this.store.select((store) => store.banks)
            .subscribe((banks) => {
                this.banks = banks.data;
            });
    }

    /**
     * Carrega dados financeiros do cliente
     */
    private loadFinance() {

        // Se inscreve na store
        this.store.select((store) => store.finance)
            .subscribe((finance) => {
                this.finance = finance.finance;
            });

        // Verifica se houve erro ao recebar dados da store
        this.disposableSubscriptions.push(
            this.financeEffects$.handleRealtimeError$
                .subscribe((result) => {
                    this.store.dispatch({
                        type: ApplicationMessagesAction.genericError,
                        payload:
                            result.payload,
                    });
                }),
        );

        // Detecta se a solicitação de saque ocorreu com sucesso ou erro.
        this.disposableSubscriptions.push(
            this.financeEffects$.getSheduletransfer$
                .subscribe((action) => {

                    if (action.type === FinanceActions.getSheduleTransferSuccess) {

                        // Direciona o cliente para o feedback de sucesso
                        this.goToFeedbackMessage();

                    } else if (action.type === FinanceActions.getSheduleTransferError) {
                        this.dispatchGenericError(action.payload);
                        this.notifyError('Tivemos um problema ao solicitar o seu saque. Por favor, tente novamente em 15 minutos.');
                    }

                    // Fecha a caixa de token
                    this.authorizationPanel.close();
                }),
        );
    }

    private notifyError(message: string, timeout = 8000) {
        this.toastrService.error(
            message,
            '',
            {
                timeOut: timeout,
                progressBar: true,
                positionClass: 'toast-bottom-center',
                toastClass: 'toast--default font-small--medium font-light-color',
            },
          );
    }

    /**
     * Carrega store de authentication
     */
    private loadAuthentication() {
        this.store.select((store) => store.authentication)
            .subscribe((authentication) => {
                this.authentication$ = authentication.currentUser;
            });

        if (this.isMobile) scrollTo(0, 0);
    }

    /**
     * Obtem a largura da tela
     */
    private getScreenWidth(): boolean {
        this.isMobile = window.innerWidth <= 768;
        return this.isMobile;
    }

    private checkWithdrawals() {
        this.disposableSubscriptions.push(
            this.store
            .select(({ finance }) => finance.withdrawHistory)
            .subscribe((withdrawHistory: WithdrawHistory[]) => {
                this.haveWithdrawalScheduled = (withdrawHistory || [])
                .some((w) => w.statusTransfer === StatusTransfer.Agendada);
            })
        );
    }

    private getCurrentUserCblc() {
        this.store.select((state) => state.authentication.currentUser)
        .pipe(
            filter(({cblc}) => !!cblc),
            first()
        )
        .subscribe(({cblc}) => {
            this.userCblc = cblc;

            // O effect do termo de LO depende do CBLC presente na store de autenticação
            this.store.dispatch({ type: OperationalLimitAction.getAcceptanceTerm });
        });
        this.isLoading = false;
    }

    private trackSubmitDraft() {
        const eventDetails = {
            requestedValue: this.formSimulation.get('rescueValue').value,
            availableValue: this.finance.availableForWithdrawal,
            cblc: this.userCblc,
            'Destination bank': this.getBankName(this.formSimulation.value.bank.bankID),
            'Account Communication Active': this.hasAccountCommunicationActive
        };

        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: 'Withdraw Requested',
                events: eventDetails,
            },
        });
    }

    /**
     * Dispara o evento de exibição do banner de Comunicação entre Contas uma única vez.
     */
    private trackAccountCommunicationBanner() {
        if (!this.hasAccountCommunicationActive || this.accountCommunicationBannerTracked) return;

        this.accountCommunicationBannerTracked = true;

        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: ActionEventsEnum.ELEMENT_LOADED,
                events: {
                    'Product Area Origin': 'Saque',
                    Group: 'Conexão entre contas',
                    Element: 'Banner comunicação entre contas',
                    Label: 'Você possui Comunicação entre Contas ativa.',
                    'Time Responsável': 'Tower',
                    cblc: this.userCblc
                },
            },
        });
    }

    private withdrawalHistoryScreenTracking() {
        const eventDetails = {
            action: ActionEventsEnum.CLICK,
            cblc: this.userCblc
        };

        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: 'Withdrawal History',
                events: eventDetails,
            },
        });
    }
}
